export default __webpack_public_path__ + "a7f4ddbc8c6033d54f24b8c1748caf06.png";